<!--     Contact Us      -->
<div class="contactus-1 section-image">
    <div class="container">
      <div class="row">
        <div class="col-md-5">
          <h2 class="title">Ready to activate your free Community Edition (CE) license?</h2>
          <h5 class="description">We want to know more about how you are using our free RegScale product to solve your most challenging compliance problems.  Tell us more about your use case so our RegScale engineers can prioritize our roadmap to focus on the features most important to you; our valued customer!</h5>
          <div class="info info-horizontal">
            <div class="icon icon-primary">
              <i class="material-icons">pin_drop</i>
            </div>
            <div class="description">
              <h4 class="info-title">Find us at our HQ</h4>
              <p> RegScale, Inc.
                <br> 1775 Tysons Boulevard, Fifth Floor
                <br> Tysons, VA 22102
              </p>
            </div>
          </div>
          <div class="info info-horizontal">
            <div class="icon icon-primary">
              <i class="material-icons">pin_drop</i>
            </div>
            <div class="description">
              <h4 class="info-title">Find us at our R&D Office</h4>
              <p> RegScale, Inc.
                <br> 2704 Cherokee Farm Way, Suite 204
                <br> Knoxville, TN 37920
              </p>
            </div>
          </div>
          <div class="info info-horizontal">
            <div class="icon icon-primary">
              <i class="material-icons">phone</i>
            </div>
            <div class="description">
              <h4 class="info-title">Give us a ring</h4>
              <p> RegScale Sales
                <br> 202-991-7881
                <br> Mon - Fri, 8:00 AM - 5:00 PM ET
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-5 ml-auto">
          <div class="card card-contact">
            <form #f="ngForm" data-toggle="validator" novalidate="true">
              <div class="card-header card-header-raised card-header-info text-center">
                <h4 class="card-title">License Registration</h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group label-floating is-empty">
                      <label class="bmd-label-floating">First name</label>
                      <input type="text" name="name" class="form-control" [(ngModel)]="reg.firstName" required>
                      <span class="material-input"></span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group label-floating is-empty">
                      <label class="bmd-label-floating">Last name</label>
                      <input type="text" name="name" class="form-control"[(ngModel)]="reg.lastName" required>
                      <span class="material-input"></span>
                    </div>
                  </div>
                </div>
                <div class="form-group label-floating is-empty">
                  <label class="bmd-label-floating">Company Name</label>
                  <input type="companyName" name="companyName" class="form-control" [(ngModel)]="reg.company" required>
                  <span class="material-input"></span>
                </div>
                <div class="form-group label-floating is-empty">
                  <label class="bmd-label-floating">Job Title</label>
                  <input type="jobTitle" name="jobTitle" class="form-control" [(ngModel)]="reg.title" required>
                  <span class="material-input"></span>
                </div>
                <div class="form-group label-floating is-empty">
                  <label class="bmd-label-floating">Email address</label>
                  <input type="email" name="email" class="form-control" [(ngModel)]="reg.email" required (input)="checkEmail()">
                  <span class="material-input"></span>
                </div>
                <div class="form-group label-floating is-empty">
                  <label class="bmd-label-floating">RegScale Instance ID</label>
                  <input type="instance" name="instance" class="form-control" [(ngModel)]="reg.instanceId" required title="NOTE: The Instance ID is available to your RegScale administrator in the Admin Panel under Setup.">
                  <span class="material-input"></span>
                </div>
                <div class="form-group mt-1">
                    <label for="primaryUseCase">Primary Use Case</label>
                    <select class="form-control select-text" name="primaryUseCase" [(ngModel)]="reg.primaryUseCase" id="primaryUseCase"
                        aria-describedby="primaryUseCase">
                        <option *ngFor="let s of cases">{{ s }}</option>
                    </select>
                </div>
                <div class="form-group label-floating is-empty">
                  <label for="exampleMessage1" class="bmd-label-floating">Describe Your Use Case</label>
                  <textarea name="message" class="form-control" id="exampleMessage1" rows="6" [(ngModel)]="reg.description" required></textarea>
                  <span class="material-input"></span>
                </div>
              </div>
              <div class="form-group text-center">
                <div class="form-check">
                  <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="bLicense" name="eula-license" id="eula-license">
                      Accept the <a href="/assets/eula-ce.pdf" target="_blank">End User Licensing Agreement</a>
                      <span class="form-check-sign">
                          <span class="check"></span>
                      </span>
                  </label>
                </div>
              </div>
              <div class="form-group text-center">
                <div class="form-check">
                  <label class="form-check-label">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="bRobot" name="robot" id="robot"> I'm not a robot
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </div>
              <div class="text-center">
                <button type="button" class="btn btn-info mb-4" (click)="save()" [disabled]="bRobot == false || bLicense == false || !f.valid">Generate License</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
   </div>
